interface BingoldLogoProps {
  size?: "small" | "medium" | "large";
  className?: string;
}

export default function BingoldLogo({
  size = "medium",
  className = "",
}: BingoldLogoProps) {
  const sizeClasses = {
    small: "w-32 h-8",
    medium: "w-40 h-10",
    large: "w-56 h-12",
  };

  return (
    <div
      className={`${sizeClasses[size]} ${className} flex items-center gap-3`}
    >
      <div>
        <img
          src="/bingold_logo.png"
          alt=""
          className="size-60 object-contain"
        />
      </div>

      <div className="relative">
        {/* 3D Metallic Effect Container */}
        <div className="relative ">
          {/* Background Glow */}
          {/* <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-yellow-600/20 blur-lg rounded-lg"></div> */}

          {/* Main Logo Container */}
          <div className="relative">
            {/* Metallic Background */}
            {/* <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/10 via-transparent to-yellow-600/10 rounded-lg"></div> */}

            {/* BINGOLD Text */}
            <div className="relative flex items-center space-x-1">
              {/* B Character with special styling */}
              {/* <span className="text-transparent bg-clip-text bg-gradient-to-br from-yellow-300 via-yellow-400 to-yellow-600 font-extrabold text-xl tracking-wider">
                M
              </span> */}

              {/* INGOLD Text */}
              {/* <span className="text-transparent bg-clip-text  bg-gradient-to-br from-[#BF961B] via-[#D2AE15] to-[#a65509] font-bold text-lg tracking-wider text-center">
                MAGNUM
              </span> */}

              {/* Subtle highlight effect */}
              {/* <div className="absolute inset-0 bg-gradient-to-t from-transparent via-yellow-400/5 to-yellow-300/10 rounded-lg pointer-events-none"></div> */}
            </div>
          </div>

          {/* 3D Depth Effect */}
          {/* <div className="absolute inset-0 transform translate-x-0.5 translate-y-0.5 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg -z-10 opacity-60"></div> */}
        </div>

        {/* Magnum Subtitle */}
        <div className="text-center flex flex-col">
          <img
            src="/bingold_logo3.png"
            alt=""
            className="w-80 h-8 object-cover"
          />
          <span className="text-transparent bg-clip-text  bg-yellow-500 text-sm font-bold uppercase">
            Airdrop
          </span>
        </div>
      </div>
    </div>
  );
}
